import { REGION_NOT_FOUND_ID } from '../utils/leadApi.constants';

export function mapRegion(dto) {
  return {
    value: String(dto.id_region),
    label: dto.region_name,
  };
}

export function mapRegions(dto) {
  if (!dto?.data) return [];
  return dto.data
    .filter((r) => r.id_region !== REGION_NOT_FOUND_ID)
    .map(mapRegion);
}

export function mapCity(dto) {
  return {
    value: String(dto.id_city),
    label: dto.city_name,
  };
}

export function mapCities(dto) {
  if (!dto?.data) return [];
  return dto.data.map(mapCity);
}
